import { handleActions } from 'redux-actions';

import { Actions } from '../constants';

const initialState = { EUR: 1 };

export default handleActions(
  {
    [Actions.LOAD_DONE]: (_, { payload: { currencyRates } }) => currencyRates,
  },
  initialState,
);
